import React, { useContext, useEffect } from 'react';
import PresetReport from '../../../components/Preset';
import { buriedPoint, typeIdObj } from '@/pages/home/utils/buriedPoint';
import { StudioContext } from '../context';
import StudioState from '../components/StudioState';

const Preset = () => {
  const { currentGame, currentMenu, menuPermission } = useContext(StudioContext);
  const { 
    preset_id: presetId = '', 
    workspace_id: wordSpaceId = '', 
    workspace_region: workSpaceRegion = '', 
    team_id: teamId ='', 
    extra_info: extInfo = '' 
  } = currentMenu || {};
  const { game_code: gameCode } = currentGame;

  // 如果有额外信息，组装presetId，组装规则<preset_id>;<workspace_id>;<workspace_region>;<team_id>
  let url = presetId;
  if (wordSpaceId && workSpaceRegion && teamId) {
    url = [presetId, wordSpaceId, workSpaceRegion, teamId].join(';');
  }

  useEffect(()=> {
    if(!currentMenu){
      return;
    }

    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '100801', 
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/preset/report/${nameEn || ''}`,
      uid: gameCode || '',
      typeId: typeIdObj.studio,
      gameName: currentGame?.game_name,
    };
    buriedPoint(logObj);

  },[currentGame, currentMenu]);

  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }

  return (
    <>
      {
        url ? <PresetReport url={`${gameCode}/${url}`} presetId={presetId} extInfo={extInfo} className='db-studio-iframe-wrap'/> : <StudioState/>
      }
    </>
  );
};

export default Preset;